// extracted by mini-css-extract-plugin
export default {"container":"DashboardPageTabs_container__GWd++","tabList":"DashboardPageTabs_tabList__Ek+eE","tabItem":"DashboardPageTabs_tabItem__w7f4e","active":"DashboardPageTabs_active__CVqaW"};